import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=24cb5eba&scoped=true"
import script from "./BasicPage.vue?vue&type=script&lang=js"
export * from "./BasicPage.vue?vue&type=script&lang=js"
import style0 from "./BasicPage.vue?vue&type=style&index=0&id=24cb5eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb5eba",
  null
  
)

export default component.exports